export function normalizeStatus(status: string) {
  switch (status) {
    case 'noIsp':
      return 'No ISP';
    default:
      return status;
  }
}
